import { configureStore } from '@reduxjs/toolkit';
import { inspectorReducers } from '@smx-ui-inspector/store/inspector-redux-state';

import { sharingDocumentSliceReducer } from './sharing-document-slice';

export const sharingDocumentReducers = {
    ...inspectorReducers,
    sharingDocument: sharingDocumentSliceReducer,
};

export const store = configureStore({
    reducer: sharingDocumentReducers,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
